import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex flex-col justify-between items-center" }
const _hoisted_2 = {
  style: {"max-width":"45rem"},
  class: "w-full h-full flex flex-col justify-between items-center"
}
const _hoisted_3 = { class: "w-3/4 max-w-md h-1/3 flex items-center justify-center" }
const _hoisted_4 = { class: "w-3/4 h-1/3 flex flex-col items-center justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-3/4 h-1/3" }, null, -1)

import { IonContent, IonPage, IonImg, toastController, loadingController } from '@ionic/vue';
import axios from 'axios';
import { Storage } from '@capacitor/storage'
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { setAppData } from '@/functions/setAppData'
import { refreshUserData } from '@/functions/refreshLogin'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter()

const email = ref("")
const password = ref("")

async function loginUser() {
  let message = ""
  if(email.value === '' && password.value === '') {
    message = 'Bitte geben sie ihre Email und ihr Passwort an'
  } else if(email.value === '') {
    message = 'Bitte geben sie ihre E-Mail an'
  } else if (password.value === '') {
    message = 'Bitte geben sie ihr Passwort an'
  }

  if(message !== '') {
    console.error(message)
    const toast = await toastController.create({
      message: message,
      cssClass: 'toast',
      duration: 2000
    })
    return await toast.present()
  }

  const loading = await loadingController.create({
      message: "Lade Daten..."
  })
  
  try {
    const response = await axios.post(process.env.VUE_APP_ZEWOTHERM_API_BASE_URL + 'jwt/login', {
      email: email.value,
      password: password.value
    })
    await loading.present()

    await Storage.set({
      key: 'email',
      value: window.btoa(email.value)
    })
    
    await Storage.set({
      key: 'password',
      value: window.btoa(password.value)
    })
  
    await Storage.set({
      key: 'jwt',
      value: response.data.access_token
    })
    
    await refreshUserData(response.data.access_token)
    await setAppData()
    await router.replace('/')
  } catch (e) {
    console.error(e)
    const toast = await toastController.create({
      message: 'Konnten sie nicht anmelden bitte überprüfe sie ihr Passwort und ihre E-Mail',
      cssClass: 'toast',
      duration: 2000
    })
    await toast.present()
  } finally {
    await loading.dismiss()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(IonImg), { src: "./assets/icon/1.png" })
              ]),
              _createElementVNode("form", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  enterkeyhint: "next",
                  type: "email",
                  class: "w-full h-10 my-1 bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none",
                  placeholder: "E-Mail"
                }, null, 512), [
                  [_vModelText, email.value]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (loginUser()), ["enter"])),
                  enterkeyhint: "send",
                  type: "password",
                  class: "w-full h-10 my-1 bg-zewotherm-lightgrey placeholder-zewotherm-grey p-2 font-bold rounded-lg outline-none",
                  placeholder: "Passwort"
                }, null, 544), [
                  [_vModelText, password.value]
                ]),
                _createElementVNode("button", {
                  id: "einloggen",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (loginUser())),
                  class: "w-full h-10 my-1 bg-zewotherm-blue p-2 text-white font-bold rounded-lg text-center outline-none active:scale-95 duration-200"
                }, "Einloggen")
              ]),
              _hoisted_5
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})